import React from 'react';
import styled, { css } from 'styled-components';

import { AlertType } from '../alert';
import { Typography } from '../typography';
import CashOutAlert from './cash-out-alert';
import { BetDetailsVariant } from '.';

export type Props = {
  status: AlertType;
  label: React.ReactNode;
  hasReprint?: boolean;
  canCashOut: boolean;
  variant?: BetDetailsVariant;
};

export default function Header({ status, label, hasReprint, canCashOut, variant = 'default' }: Props) {
  return (
    <Wrapper>
      {canCashOut ? (
        <CashOutAlert />
      ) : (
        <Alert className="qa-bet-finder-status" type={status} variant={variant}>
          {label}
        </Alert>
      )}
      {hasReprint && (
        <Alert type={AlertType.INFO} variant="compact">
          This ticket has been reprinted
        </Alert>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

const Alert = styled(Typography).attrs<{ variant?: BetDetailsVariant }>(({ variant }) => ({
  as: 'p',
  size: variant === 'compact' ? 'xl' : '2xl',
  weight: variant === 'compact' ? 500 : 700
}))<{
  type: AlertType;
  variant?: BetDetailsVariant;
}>`
  ${({ variant, type, theme }) => css`
    background-color: ${theme.colors.status[type]};
    color: ${[AlertType.ERROR, AlertType.EXPIRED].includes(type)
      ? theme.colors.white
      : theme.components.global.textColor};
    padding: ${variant === 'compact' ? '1.6rem 0' : '2.4rem 0'};
  `};
  margin: 0;
  text-align: center;
`;
